import React from 'react';
import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import {
  getUnreadRequests,
  invalidateRequests,
} from '../../services/appointments';
import useSocket from '../socket/useSocket';

function useGetUnreadRequests({
  enabled = true,
  listen = false,
}: {
  enabled?: boolean;
  listen?: boolean;
} = {}) {
  const socket = useSocket();
  const { user } = useUser();

  const { data, isLoading, isRefetching, isFetching, isError, refetch } =
    useQuery({
      queryKey: ['unread-requests', user?.business?.id, user?.userId],
      queryFn: async () => {
        const unreadRequests = await getUnreadRequests(user?.business?.id);
        return unreadRequests;
      },
      enabled: !!user && enabled,
    });

  React.useEffect(() => {
    if (!listen || !user?.business.id) return undefined;

    const onNewRequest = () => {
      refetch();
      invalidateRequests('REQUESTED');
    };

    socket.on('newRequest', onNewRequest);

    return () => {
      socket.off('newRequest', onNewRequest);
    };
  }, [socket, listen, refetch, user?.business.id]);

  return {
    data,
    isLoading,
    isRefetching,
    isFetching,
    isError,
    refetch,
  };
}

export default useGetUnreadRequests;
